<template>
  <div>
    <div class="text-right">
      <b-dropdown split split-href="#" :text="$t('task.download-options')" size="sm" variant="light" class="m-2">
        <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
      </b-dropdown>
    </div>

    <div class="table-responsive">
      <table class="table" style="width: 100%;">
        <thead>
          <tr>
            <th>{{ $t("risk.definition.text") }}</th>
            <th>{{ $t("risk.threat-definition.text") }}</th>
            <th>{{ $t("risk.weakness-definition.text") }}</th>
            <th>{{ $t("risk.source.text") }}</th>
            <th>{{ $t("risk.compliance") }}</th>
            <th>{{ $t("risk.category.text") }}</th>
            <th>{{ $t("risk.applied-risk-value.text") }}</th>
            <th>{{ $t("risk.status.text") }}</th>
            <th>{{ $t("risk.applied-risk-decision.text") }}</th>
            <th>{{ $t("asset-group.text") }}</th>
            <th>{{ $t("risk.owner") }}</th>
            <th>{{ $t("risk.data-owner") }}</th>
            <th>{{ $t("risk.admin") }}</th>
            <th style="width: 15%">
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-muted">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
          <tr v-if="filterEnabled">
            <th><input v-model="nameFilter" class="form-control" type="text" :placeholder="$t('common.search')" /></th>
            <th></th>
            <th></th>
            <th></th>
            <th>
              <select class="form-control " v-model="productFilter">
                <option :value="undefined">{{ $t("common.clear-selection") }}</option>
                <option v-for="item in scopedProducts" :key="item" :value="item">{{ item }}</option>
              </select>
            </th>
            <th>
              <select class="form-control " v-model="categoryFilter">
                <option :value="undefined">{{ $t("common.clear-selection") }}</option>
                <option value="ADMINISTRATIVE">{{ $t("risk.category.administrative") }}</option>
                <option value="TECHNICAL">{{ $t("risk.category.technical") }}</option>
                <option value="LEGAL">{{ $t("risk.category.legal") }}</option>
              </select>
            </th>
            <th>
              <select class="form-control" v-model="degreeFilter">
                <option :value="undefined">{{ $t("common.clear-selection") }}</option>
                <option value="LOWEST">{{ $t("risk.applied-risk-value.lowest") }}</option>
                <option value="LOW">{{ $t("risk.applied-risk-value.low") }}</option>
                <option value="MEDIUM">{{ $t("risk.applied-risk-value.medium") }}</option>
                <option value="HIGH">{{ $t("risk.applied-risk-value.high") }}</option>
                <option value="HIGHEST">{{ $t("risk.applied-risk-value.highest") }}</option>
              </select>
            </th>
            <th>
              <select class="form-control" v-model="statusFilter">
                <option :value="undefined">{{ $t("common.clear-selection") }}</option>
                <!-- <option value="RATING">{{ $t("risk.status.rating") }}</option> -->
                <option value="ACTIVE">{{ $t("risk.status.active") }}</option>
                <option value="INACTIVE">{{ $t("risk.status.inactive") }}</option>
              </select>
            </th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="pagination && pagination.docs.length">
          <tr v-for="item in pagination.docs" :key="item._id" class="hider">
            <td>
              <div>{{ item.name | translate }}</div>
            </td>
            <td>
              <div>{{ displayDefinitions(item.threats) }}</div>
            </td>
            <td>
              <div>{{ displayDefinitions(item.weaknesses) }}</div>
            </td>
            <td>
              <div>{{ displayRiskSource(item.source) }}</div>
            </td>
            <td>
              <div>{{ displayCompliances(item.products) }}</div>
            </td>
            <td>
              <div class="rdescription"><risk-category-badge :risk="item" /></div>
            </td>
            <td>
              <div>{{ displayRiskValue(item.appliedRiskValue) }}</div>
            </td>
            <td>
              <div>{{ displayRiskStatus(item.status) }}</div>
            </td>
            <td>
              <div>{{ displayRiskDecision(item.appliedRiskDecision) }}</div>
            </td>
            <td>
              <div v-if="item.assetGroup">{{ item.assetGroup.name | translate }}</div>
            </td>
            <td>
              <div>{{ displayRiskOwner(item.owner) }}</div>
            </td>
            <td>
              <div v-if="item.dataOwner && item.dataOwner.department">{{ item.dataOwner.department.name | translate }}</div>
              <div v-if="item.dataOwner && item.dataOwner.process">{{ item.dataOwner.process.name | translate }}</div>
              <div v-if="item.dataOwner && item.dataOwner.organization">{{ item.dataOwner.organization.name }}</div>
            </td>
            <td>
              <div v-if="item.admin">{{ item.admin.name }}</div>
            </td>
          </tr>
        </tbody>
      </table>

      <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
        <h5 class="text-center">
          {{ $t("asset-group.empty") }}
        </h5>
      </empty>

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RiskCategoryBadge from "./component/risk-category-badge";
export default {
  components: { RiskCategoryBadge },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: { status: { value: { $ne: "RATING" }, isObject: true } },
      },
      filterEnabled: true,
      nameFilter: undefined,
      categoryFilter: undefined,
      productFilter: undefined,
      degreeFilter: undefined,
      statusFilter: undefined,
    };
  },

  computed: {
    pagination() {
      return this.$store.getters["organizationRisk/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationRisk/isLoading"];
    },
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },

    categoryFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, category: { value: n, isObject: true } };
      } else {
        this.request.query["category"] = null;
        delete this.request.query["category"];
      }
    },
    statusFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, status: { value: n, isObject: true } };
      } else {
        this.request.query["status"] = null;
        delete this.request.query["status"];
      }
    },
    degreeFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, appliedRiskValue: { value: n, isObject: true } };
      } else {
        this.request.query["appliedRiskValue"] = null;
        delete this.request.query["appliedRiskValue"];
      }
    },
    productFilter(n, o) {
      if (!n) {
        this.request.query["products"] = null;
        delete this.request.query["products"];
        return;
      }
      this.request.query = {
        ...this.request.query,
        products: { value: n, isObject: true },
      };
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },

  mounted() {
    this.handleQueryParams();
  },
  methods: {
    displayDefinitions(array) {
      if (!array || !array.length) {
        return "";
      }
      return array.map((i) => i.name[this.currentLanguage]).join(", ");
    },
    async paginate() {
      await this.$store.dispatch("organizationRisk/paginate", this.request);
    },
    displayRiskValue(value) {
      if (!value) return "";
      return this.$t(`risk.applied-risk-value.${value?.toLowerCase()}`);
    },
    displayCompliances(value) {
      if (!value) return "";
      const index = value.findIndex((item) => item == "PLATFORM");
      value[index] = this.$t("common.corporate");
      return value.join(",");
    },
    displayRiskSource(value) {
      if (!value) return "";
      let key;
      if (value == "COMPELLING") {
        key = "compelling";
      } else if (value == "INTENTIONAL") {
        key = "intentional";
      } else if (value == "UNINTENTIONAL") {
        key = "unintentional";
      } else if (value == "INTENTIONAL_UNINTENTIONAL_COMPELLING") {
        key = "intentional-unintentional-compelling";
      }
      if (!key) return "";
      return this.$t(`risk.source.${key}`);
    },
    displayRiskStatus(value) {
      return this.$t(`risk.status.${value?.toLowerCase()}`);
    },
    displayRiskDecision(value) {
      return value ? this.$t(`risk.applied-risk-decision.${value?.toLowerCase()}`) : "";
    },
    displayRiskOwner(value) {
      return value == "ORGANIZATION" ? this.$t("organization.text") : value == "DEPARTMENT" ? this.$t("department.text") : this.$t("process.text");
    },
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 15, sort: { name: "asc" } },
          query: {},
        };
        this.nameFilter = undefined;
      }
    },
    async downloadExcel() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const payload = { organization: { _id: this.currentOrganization?._id, name: this.currentOrganization?.name } };

        if (this.activeTab == "approval") {
          payload.downloadScope = "ACCOUNT_IN_ORGANIZATION";
        } else if (this.activeTab == "unworked") {
          payload.downloadScope = "UNWORKED_IN_ORGANIZATION";
        }

        const { data: file } = await this.$store.dispatch(`organizationRisk/download`, payload);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    handleQueryParams() {
      const queryParams = this.$route.query;

      const safeCategories = ["ADMINISTRATIVE", "LEGAL", "TECHNICAL"];

      if (!queryParams) {
        return;
      }

      if (queryParams.category && safeCategories.includes(queryParams.category)) {
        this.categoryFilter = queryParams.category;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../task/tasks.scss";
</style>
